import { useUnmount } from 'ahooks';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { isPlatformOrg } from 'domains/orgDomain';
import { useOrgId } from 'hooks/useOrg';
import { useEffect } from 'react';
import { ParcelBaseSelect } from './ParcelBaseSelect';
import { ParcelTable } from './ParcelTable';
import ParcelItemForm from './ParceltemForm';

const ParcelAdmin = () => {
  const curItem = useAppSelector((state) => state.parcel.curItem);
  const orgId = useOrgId();
  const isBaseOrg = isPlatformOrg({ id: orgId });
  const baseSelectCurItem = useAppSelector(
    (state) => state.parcel.baseSelectState.curItem
  );
  const dispatch = useAppDispatch();

  useUnmount(() => {
    dispatch.parcel.reset();
    dispatch.app.setState({
      filterForceHidden: false,
    });
  });

  useEffect(() => {
    if (curItem) {
      dispatch.app.setState({
        filterForceHidden: true,
      });
    } else {
      dispatch.app.setState({
        filterForceHidden: false,
      });
    }
  }, [curItem, dispatch.app]);

  return (
    <>
      <ParcelTable />
      {!isBaseOrg && <ParcelBaseSelect />}
      {curItem && <ParcelItemForm isBaseSelect={false} />}
      {baseSelectCurItem && <ParcelItemForm isBaseSelect />}
    </>
  );
};

export default ParcelAdmin;
